// Polling + exponential backoff function
const waitForTimeout = duration => new Promise(res => setTimeout(res, duration));

export default function poll(customDataValidator, retries = 1, delay = 200) {
  if (!retries || typeof customDataValidator !== 'function') {
    return Promise.reject(false);
  }

  return customDataValidator()
    .then(response => Promise.resolve(response))
    .catch((err) => {
      if (retries) {
        return waitForTimeout(delay)
          .then(() => poll(customDataValidator, retries - 1, delay * 2));
      }
      return Promise.reject(err);
    });
}

/*
EXAMPLE of how to use this file:

var data;  <- variable that's defined but has no data in it yet.

// Let's simulate server lag time.
setTimeout(() => {
  data = 'hello!!!';
}, 10);


// This is a custom validator function which makes it so our poll function can be super generic since it doesn't care about how to validate data
function testForData() {
  return (data) ? Promise.resolve(data) : Promise.reject(false);
}

poll(testForData, 3, 100)
 .then((resp) => console.log(resp))
 .catch((err) => console.log(err));

*/
